import { Assets } from 'pixi.js';
export const TEMPLATE_GAME_ASSETS = {
  images: [
    { key: 'reef_background', src: '/assets/reef_background.jpg' },
    { key: 'cannon', src: '/assets/cannon.svg' },
    { key: 'fish_small', src: '/assets/fish_small.svg' },
    { key: 'fish_boss', src: '/assets/fish_boss.svg' },
  ],
  audio: [],
  fonts: [],
};
export async function preload() {
  await Assets.load(TEMPLATE_GAME_ASSETS.images.map((asset) => asset.src));
}